export const generateRandomPassword = (length) => {
  length = length || 12;
  var charset = 'abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789!@#$%&';
  var password = '';
  // Ensure at least one of each type
  password += 'ABCDEFGHJKLMNPQRSTUVWXYZ'[Math.floor(Math.random() * 24)];
  password += 'abcdefghijkmnopqrstuvwxyz'[Math.floor(Math.random() * 25)];
  password += '23456789'[Math.floor(Math.random() * 8)];
  password += '!@#$%&'[Math.floor(Math.random() * 6)];

  for (var i = password.length; i < length; i++) {
    password += charset[Math.floor(Math.random() * charset.length)];
  }
  // Shuffle
  return password.split('').sort(function() { return 0.5 - Math.random(); }).join('');
}